// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "87a4d4d4b7377e6e95fc2593103e77a5999f8181/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};